import * as React from 'react';
import { camelCase, isNil } from 'lodash';

import { __t, applyTranslations } from 'utils/language';
import { REPORTING_TASK_TYPE_ORDER } from 'utils/reporting';
import { renderPrice } from 'utils/helper/price';

import ReportingStatisticTable from '../reporting-statistic-table/ReportingStatisticTable';

applyTranslations(require('./campaign-media-value-table.i18n.json'));

type CampaignReportMediaValue = {
  [x: string]: number
};

type Props = {
  deliverableTypesToShow: Array<string>,
  mediaValue: CampaignReportMediaValue
};

const CampaignMediaValueTable = (
  {
    mediaValue,
    deliverableTypesToShow = []
  }: Props
): JSX.Element => {
  const items = REPORTING_TASK_TYPE_ORDER
    .filter(type => {
      const key = camelCase(type);
      return !isNil(mediaValue[key]) && deliverableTypesToShow.includes(type);
    })
    .map(type => ({
      key: type,
      label: __t(`campaign_media_value_table.label.${type}`),
      value: renderPrice(mediaValue[camelCase(type)], { separateThousands: true }),
      tooltip: __t(`campaign_media_value_table.tooltip.${type}`)
    }));

  return (
    <ReportingStatisticTable
      items={items}
    />
  );
};

export default CampaignMediaValueTable;
